import ApiService from '@/services/core/api.service'

const DashboardService = {
  async getCampaigns (query = '') {
    return ApiService.get(`supervisor/dashboard/campaigns?${query}`)
  }
}

export default DashboardService
